// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrendingTagResults_TagResults__5QRZ6{
    box-shadow:3px 3px 3px rgb(163, 177, 198, 0.6), -6px -6px 12px rgba(255, 255, 255, 0.5);
    border-radius: 20px 0px 0px 20px;
    box-sizing: border-box;
    overflow-y: scroll;
    height: 812px;
    scrollbar-width: thin;
    scrollbar-color:#6b71c9;
    width: -moz-available;
    padding:20px;
}
.TrendingTagResults_TagResultContainer__Ixnnc{
    /* display: flex; */
    /* align-items: center; */
    width: 100%;
    padding: 0px 20px;
}
.TrendingTagResults_trendingTagImage__CB8hX{
    margin-bottom: 3px;
    margin-right: 8px;
}
.TrendingTagResults_trendingTagHeading__hct9O{
    margin: auto;
    font-size: 20px;
    margin-left: 10px;
    color: #373334;
    font-weight: 700;
}
.TrendingTagResults_loader__-rd1-{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-top: 60px;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Assets/css/home/TrendingTagResults.module.css"],"names":[],"mappings":"AAAA;IACI,uFAAuF;IACvF,gCAAgC;IAChC,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf","sourcesContent":[".TagResults{\r\n    box-shadow:3px 3px 3px rgb(163, 177, 198, 0.6), -6px -6px 12px rgba(255, 255, 255, 0.5);\r\n    border-radius: 20px 0px 0px 20px;\r\n    box-sizing: border-box;\r\n    overflow-y: scroll;\r\n    height: 812px;\r\n    scrollbar-width: thin;\r\n    scrollbar-color:#6b71c9;\r\n    width: -moz-available;\r\n    padding:20px;\r\n}\r\n.TagResultContainer{\r\n    /* display: flex; */\r\n    /* align-items: center; */\r\n    width: 100%;\r\n    padding: 0px 20px;\r\n}\r\n.trendingTagImage{\r\n    margin-bottom: 3px;\r\n    margin-right: 8px;\r\n}\r\n.trendingTagHeading{\r\n    margin: auto;\r\n    font-size: 20px;\r\n    margin-left: 10px;\r\n    color: #373334;\r\n    font-weight: 700;\r\n}\r\n.loader{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding-top: 60px;\r\n    width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TagResults": `TrendingTagResults_TagResults__5QRZ6`,
	"TagResultContainer": `TrendingTagResults_TagResultContainer__Ixnnc`,
	"trendingTagImage": `TrendingTagResults_trendingTagImage__CB8hX`,
	"trendingTagHeading": `TrendingTagResults_trendingTagHeading__hct9O`,
	"loader": `TrendingTagResults_loader__-rd1-`
};
export default ___CSS_LOADER_EXPORT___;
